import { toast } from 'sonner';
import { AlertCircle } from 'lucide-react';

type ErrorToastProps = {
  title?: string;
  description?: string;
};

export const showErrorToast = ({
  title = 'Something went wrong',
  description = 'Please wait a moment and try again.',
}: ErrorToastProps = {}) => {
  toast.error(title, {
    description,
    icon: <AlertCircle className="h-5 w-5 text-[#DC2626] mt-2" />,
    closeButton: true,
    classNames: {
      closeButton: `text-[#DC2626] right-0 mt-3 border-none background-none left-[inherit] opacity-0 group-hover/item:opacity-100 transition-opacity`,
      toast: `group/item pl-6 pr-8 py-6`,
    },
  });
};
